import { useIsomorphicLayoutEffect } from "usehooks-ts";
import { useAuthStore } from "@/features/auth/stores/authStore";
import { useUserEventFilters } from "@/hooks/firestore/user/useUserEventFilters";
import { useBetslipStore } from "@/features/betslip/stores/betslipStore";
import { sameFilters } from "@/features/betslip/stores/slices/session";

/**
 * Mirrors the session into the slip
 */
export const useSyncSession = () => {
  const permissions = useAuthStore((state) =>
    state.status === "loading" ? null : state.session.permissions,
  );
  const userEventFilters = useUserEventFilters();
  const setSession = useBetslipStore((state) => state.setSession);

  useIsomorphicLayoutEffect(() => {
    // Only on a real difference: the store notifies on every write, including
    // this one, so an unguarded sync would call itself forever.
    const sync = () => {
      const stored = useBetslipStore.getState();
      if (
        stored.permissions === permissions &&
        sameFilters(stored.userEventFilters, userEventFilters)
      ) {
        return;
      }
      setSession({ permissions, userEventFilters });
    };
    sync();
    // Logout resets the slip, session included - put it back when that happens.
    return useBetslipStore.subscribe(sync);
  }, [permissions, userEventFilters, setSession]);
};
